/* @ngInject */
function ChatController ($scope, $translate, $timeout, MessageService, $rootScope) {
  $scope.filterOptions = [
    { label: $translate.instant('shareDialog.public'), value: 'public' },
    { label: $translate.instant('private'), value: 'private' },
    { label: $translate.instant('APPROVALS'), value: 'approvals' }
  ]

  $scope.messages = []
  $scope.messagesCount = null
  $scope.flags = {
    loading: true,
    buttonLoading: false,
    disabledInputRichText: false
  }

  const top = 6
  let index = 0
  let filter = null

  const api = {
    _successGetMessages,
    _initializeInfiniteScroll,
    _handleDelete,
    _sortMessages,
    _preventDuplicatedMessages
  }
  this.getApi = () => api

  activate()

  function activate () {
    if (!$scope.inputType) {
      $scope.inputType = 'public'
    }

    $scope.getMessages(top, 0, null).then((res) => api._successGetMessages(res, true)).finally(() => { $scope.flags.loading = false })
  }

  const deregisterTask = $scope.$watch('task', (newValue) => {
    updateDisabledInputRichText()
  })

  const deregisterBoard = $scope.$watch('board', (newValue) => {
    updateDisabledInputRichText()
  })

  function updateDisabledInputRichText () {
    if ($rootScope.isUser() && $scope?.task?.status === 'DONE') {
      $scope.flags.disabledInputRichText = !$scope?.board?.allowUserComment
    } else {
      $scope.flags.disabledInputRichText = false
    }
  }

  const deregisterUpdateMessages = $scope.$watch('updateMessages', (newValue) => {
    if (newValue) {
      $scope.updateMessages = false
      activate()
    }
  })

  $scope.$on('$destroy', () => {
    deregisterUpdateMessages()
    deregisterTask()
    deregisterBoard()
  })

  $scope.onFilterChange = (event) => {
    filter = event.detail?.value || null
    index = 0
    $scope.flags.loading = true
    $scope.getMessages(top, top * index, filter).then((res) => api._successGetMessages(res, true)).finally(() => { $scope.flags.loading = false })
  }

  $scope.onTabChange = (type) => {
    $scope.inputType = type
    if ($scope.onTab) {
      $scope.onTab(type)
    }
  }

  $scope.getInputPlaceholder = () => {
    return $scope.inputType === 'public' ? $scope.inputPlaceholder : $scope.inputPrivatePlaceholder
  }

  $scope.loadMore = () => {
    $scope.flags.buttonLoading = true
    index++
    let skip = top * index

    if (skip !== $scope.messages.length) {
      skip = $scope.messages.length
    }

    $scope.getMessages(top, skip, filter).then(api._successGetMessages).finally(() => { $scope.flags.buttonLoading = false })
  }

  $scope.onLastItemLoad = function () {
    $timeout(() => {
      const container = $('.chat-container .messages-container')
      container.scrollTop(container[0].scrollHeight)
    }, 100, false)

    $timeout(() => {
      api._initializeInfiniteScroll()
    }, 1500, false)
  }

  $scope.onSendComment = (info) => {
    $scope.onSend(info).then((response) => {
      $scope.messages.push(response)
      $scope.messagesCount++
    })
  }

  $scope.onDeleteComment = (info) => {
    MessageService.warning({
      title: $translate.instant('warning'),
      text: $translate.instant('areYouSureDeleteComment'),
      cancelButton: $translate.instant('no'),
      confirmButton: $translate.instant('yes'),
      closeOnConfirm: true,
      press: api._handleDelete.bind(this, info)
    })
  }

  $scope.onEditComment = (info) => {
    $scope.onEdit(info).then(() => {
      const index = $scope.messages.findIndex(item => item.id === info.message.id)

      if (index !== -1) {
        $scope.messages[index].value = info.message.value
      }
    })
  }

  function _successGetMessages (res, reset) {
    if (reset) {
      $scope.messages = []
    }

    const rows = res?.d?.results || res.rows

    if (rows) {
      api._sortMessages(rows)
      const filteredMessages = api._preventDuplicatedMessages(rows)
      $scope.messages.unshift(...filteredMessages)
      $scope.messagesCount = parseInt(res.count)
    }
  }

  function _initializeInfiniteScroll () {
    $timeout(() => {
      const container = $('.chat-container .messages-container')

      if (container.length) {
        container.scroll(() => {
          const loading = $scope.flags.loading || $scope.flags.buttonLoading

          if (!loading && $scope.messagesCount > $scope.messages.length && container.scrollTop() === 0) {
            $scope.loadMore()
          }
        })
      }
    }, 500, false)
  }

  function _handleDelete (info) {
    $scope.onDelete(info).then(() => {
      const index = $scope.messages.findIndex(item => item.id === info.id)

      if (index !== -1) {
        $scope.messages.splice(index, 1)
        $scope.messagesCount--
      }
    })
  }

  function _sortMessages (messages) {
    messages.sort((a, b) => {
      return new Date(a.createdAt) - new Date(b.createdAt)
    })
  }

  function _preventDuplicatedMessages (messages) {
    const filteredMessages = messages.filter(value => {
      return !$scope.messages.some(item => item.id === value.id)
    })
    return filteredMessages
  }

  $scope.onHoverComment = (message) => {
    if (message.id) {
      $scope.hoverCommentId = message.id
    }
  }

  $scope.onBlurComment = () => {
    $scope.hoverCommentId = null
  }

  $scope.showChatMessage = (messageValue, messageType, messageAsset) => {
    const isPreviewAndHasApproval = $scope.isPreview && messageType === 'TASK_APPROVAL_STATUS_UPDATE'
    const hasNotApproval = messageType !== 'TASK_APPROVAL_STATUS_UPDATE'
    const hasNotAsset = !$scope.isPreview && !messageAsset && messageType === 'TASK_APPROVAL_STATUS_UPDATE'

    return messageValue && (isPreviewAndHasApproval || hasNotApproval || hasNotAsset)
  }

  $scope.showApprovalMessage = (messageType, messageAsset) => {
    return messageType === 'TASK_APPROVAL_STATUS_UPDATE' && messageAsset && !$scope.isPreview
  }
}

export { ChatController }
